// src/components/contact/ContactCardsSection.jsx
import React from "react";
import AddressCard, { getAddressCardUrl } from "./AddressCard";

const ContactCardsSection = ({ addressCards = [] }) => {
  const visibleCards = addressCards.filter((card) => getAddressCardUrl(card));

  return (
    <div className="space-y-6">
      {visibleCards.length > 0 ? (
        visibleCards.map((card, index) => (
          <AddressCard
            key={card.id || card.documentId || index}
            card={card}
            delay={index * 150}
          />
        ))
      ) : (
        <div className="panel-elevated rounded-2xl p-8 text-center">
          <p className="text-gray-600 text-lg">
            No contact information available at the moment.
          </p>
        </div>
      )}
    </div>
  );
};

export default ContactCardsSection;
